import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6f2507a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-red mr5"
}
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"right","padding":"5px 0"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 管理项目角色 > ")

import { PropType, ref, onMounted, nextTick } from "vue";
import { TeamService } from "@/views/project/team/team.service";
import { DEFAULTCOUNTMAX, DEFAULTPRICELENGTH, DEFAULTTABLEMAXHEIGHT } from "@/core/constant";
import { message } from "ant-design-vue";
import { DictValService } from "@/views/data-dict/dict/dict-val.service";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  row: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  showCount: {
    type: Boolean,
    default: false,
  },
  btnText: {
    type: String,
    default: "调整团队",
  },
  isBtn: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  projectId: {
    type: String,
    default: "",
  },
  projectName: {
    type: String,
    default: "",
  },
  dataRecord: {
    type:  Array as PropType<any>,
    default: () => ([]),
  },
},
  emits: ["refresh","addRows"],
  setup(__props, { emit: emits }) {

const props = __props

const columns = [
  {
    width: 160,
    key: "roleName",
    title: "项目角色",
    slots: { customRender: "roleName" },
  },
  {
    width: 500,
    key: "teams",
    slots: { customRender: "teams" },
    title: "人员",
  },
];
const columns2 = [
  {
    width: 160,
    key: "roleName",
    title: "项目角色",
  },
  
];
let tableRef=ref();


const { data, loading, run, refresh } = TeamService.useTeamUserApi();
const { run: runEdit } = TeamService.useUpdateTeamUserApi();
const { run: runByProjectId } = TeamService.useTeamUserByProjectIdApi();
const { run: runTeamRolesByProjectId } = TeamService.useTeamRolesApi();
const { run: runUpdateTeamRolesByProjectId } = TeamService.useUpdateTeamRolesApi();
const visible = ref(false);
const visible2 = ref(false);
const dataSource = ref([]);
const dataSource2:any = ref([]);
const selectedIds = ref<any>([]);
    const onSelectionChange = (ids: string[]) => {
      selectedIds.value = ids;
      console.log(selectedIds.value);
    };
const setTeam = async () => {
  const res = await run(props.row.id);
  dataSource.value = res?.data.records;
  visible.value = true;
};

const checkMethod=({row})=>{
  return row.roleName!=="项目负责人"
}

const setTeamByProjectId = async () => {
  if(props.dataRecord&&props.dataRecord.length>0){
    dataSource.value = props.dataRecord;
  }else{
    const res = await runByProjectId(props.projectId);
   dataSource.value = res?.data.records;
  }
 
  visible.value = true;
};
const handleOk = async () => {
  let req: any = [];
  let tmp: any = [];
  dataSource.value.map((dd: any) => {
    if ("xmfzr" == dd.code && (!dd.tenantUserIds || dd.tenantUserIds.length == 0)) {
      tmp.push("项目负责人不可为空");
    }
    if (!dd.tenantUserIds) {
      dd.tenantUserIds=[]
      req.push({
        code: dd.code,
        tenantUserId: 0,
      });
    } else if (Array.isArray(dd.tenantUserIds)) {
      if(dd.tenantUserIds.length){
        for (let i = 0; i < dd.tenantUserIds.length; i++) {
        req.push({
          code: dd.code,
          tenantUserId: dd.tenantUserIds[i],
        });
       }
      }else{
        req.push({
          code: dd.code,
          tenantUserId: null,
        });
      }
     
    } else {
      req.push({
        code: dd.code,
        tenantUserId: dd.tenantUserIds,
      });
      dd.tenantUserIds=[dd.tenantUserIds]
    }
  });

  if (tmp.length > 0) {
    message.warning(tmp[0]);
    return;
  }
  if(props.projectId){    
    emits("addRows",dataSource.value);
  }else{
    await runEdit(props.row.id, req);
    emits("refresh");
  }
 
  visible.value = false;
};
const checkRowKeys:any=ref([])
const openModel =async () => {
  visible2.value = true;
  let res=await runTeamRolesByProjectId(props.row.projectId||props.projectId);
  console.log("🚀 ~ openModel ~ res:", res,dataSource2)
  dataSource2.value=res?.data.records||[];

  nextTick(()=>{
    const $table = tableRef.value;
     
    dataSource2.value.forEach((item:any)=>{
    if(item?.selectFlag&&$table){
      selectedIds.value.push(item?.tenantDictValId)
      // checkRowKeys.value.push(item?.tenantDictValId)
      $table.xTable1.setCheckboxRow(item, true);
    }
  })
  })
 
};
const handleOk2 = async () => {
  let params:any=[];
  dataSource2.value.forEach((item:any)=>{

    console.log("🚀 ~ handleOk2 ~ item:", item)

    params.push({
      tenantDictValId:item.tenantDictValId,
      projectId:props.row.projectId||props.projectId,
      selectFlag:Number(selectedIds.value.includes(item.tenantDictValId))
    })  
  })
  await runUpdateTeamRolesByProjectId(props.row.projectId||props.projectId,params);
  const res = await run(props.row.id);
  dataSource.value = res?.data.records;
 
  visible2.value = false;
};
onMounted(async() => {
  // await run2()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isBtn)
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setTeamByProjectId()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.btnText), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.isBtn && __props.showCount)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "javascript:void(0)",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setTeam()))
        }, _toDisplayString(__props.row?.teamsCount), 1))
      : _createCommentVNode("", true),
    (!__props.isBtn && !__props.showCount)
      ? _withDirectives((_openBlock(), _createElementBlock("a", {
          key: 2,
          href: "javascript:void(0)",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setTeam()))
        }, [
          _createTextVNode(_toDisplayString(__props.btnText), 1)
        ])), [
          [_directive_perm, 'set-team']
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      centered: true,
      maskClosable: false,
      width: "820px",
      title: (__props.row?.projectName||__props.projectName) + '团队',
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_table_wrapper, {
          "row-key": 'uuid',
          dataSource: dataSource.value,
          columns: columns,
          showCheckbox: false,
          showTooTip: false,
          maxHeight: _unref(DEFAULTTABLEMAXHEIGHT),
          "row-config": {height: 120}
        }, {
          teams: _withCtx(({ record }) => [
            _createVNode(_component_user_select, {
              validate: 'xmfzr' == record.code,
              value: record.tenantUserIds,
              "onUpdate:value": ($event: any) => ((record.tenantUserIds) = $event),
              disabled: __props.disabled,
              multiple: true,
              "max-count": ['xmfzr', 'tbfzr', 'fafzr', 'xmjl'].includes(record.code) ? 1 : Infinity
            }, null, 8, ["validate", "value", "onUpdate:value", "disabled", "max-count"])
          ]),
          roleName: _withCtx(({ record }) => [
            ('xmfzr' == record.code)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(record?.roleName), 1)
          ]),
          _: 1
        }, 8, ["dataSource", "maxHeight"]),
        (__props.row?.projectId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: openModel,
                type: "link"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })), [
                [_directive_perm, '/data-dict/dict/list/project']
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: visible2.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible2).value = $event)),
      centered: true,
      maskClosable: false,
      width: "420px",
      title: '管理项目角色',
      onOk: handleOk2
    }, {
      default: _withCtx(() => [
        _createVNode(_component_table_wrapper, {
          "row-key": 'tenantDictValId',
          ref_key: "tableRef",
          ref: tableRef,
          dataSource: dataSource2.value,
          columns: columns2,
          showCheckbox: true,
          showTooTip: false,
          onOnSelectionChange: onSelectionChange,
          maxHeight: _unref(DEFAULTTABLEMAXHEIGHT),
          "row-config": {height: 120},
          "checkbox-config": {checkMethod: checkMethod,checkRowKeys: checkRowKeys.value}
        }, null, 8, ["dataSource", "maxHeight", "checkbox-config"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})